import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

import { focusRing } from '../styles/focus-ring';

export const toggleVariants = cva(
  cn(
    'inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors hover:bg-background-secondary hover:text-text-secondary disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-background-secondary data-[state=on]:text-text-primary',
    focusRing
  ),
  {
    variants: {
      variant: {
        default: 'bg-transparent',
        outline:
          'border border-border bg-transparent hover:bg-background-secondary hover:text-text-primary',
      },
      size: {
        default: 'h-10 px-3',
        sm: 'h-9 px-2.5',
        lg: 'h-11 px-5',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
